import { StyleSheet } from 'react-native';
import { getBoxShadow } from 'src/helpers/style.helper';

import { background, neutrals } from 'src/theme/colors';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'column',
    backgroundColor: neutrals.white,
  },
  header: {
    height: 60,
    justifyContent: 'center',
    alignItems: 'center',
    ...getBoxShadow({
      color: neutrals.black,
      offsetX: 0,
      offsetY: 0,
      blurRadius: 20,
      opacity: 0.1,
    }),
  },
  contentWrapper: {
    flexGrow: 2,
    justifyContent: 'center',
    alignItems: 'center',
    marginHorizontal: 40,
    marginTop: 32,
    marginBottom: 36,
    backgroundColor: background.backgroundColorBrand,
    borderRadius: 20,
    paddingHorizontal: 16,  
  },
  content: {
    maxWidth: 500,
  },
  iconWrapper: {
    alignSelf: 'center',
    marginBottom: 24,
  },
  title: {
    fontSize: 24,
    fontWeight: 700,
    textAlign: 'center',
    marginBottom: 8,
  },
  description: {
    fontSize: 18,
    fontWeight: 400,
    textAlign: 'center',
  },
  button: {
    marginTop: 24,
  },
});
